/* eslint-disable import/no-extraneous-dependencies */
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { useEffect, useRef } from 'react';
import { useProductEditor } from '../InvoiceProductEditorProvider';
import { ProductInputField, ProductTextAreaField } from '../components/ProductEditorInputs';

const toolbarConfig = {
    items: [
        'undo',
        'redo',
        '|',
        'heading',
        '|',
        'bold',
        'italic',
        'link',
        'bulletedList',
        'numberedList'
    ]
};

function PremiumContractInputs() {
    const contRef = useRef();
    useEffect(() => {
        if (contRef.current) {
            const modalParentDiv = contRef.current.closest('.modal-box-content');
            if (modalParentDiv) {
                modalParentDiv.style.width = '500px';
            }
        }
    }, []);

    const { setFormData, formData } = useProductEditor();

    return (
        <div ref={contRef} className="inputs-cont flex-row flex-wrap align-space-between ">
            {/* <ProductTextAreaField title="Description" name="pcDescription" /> */}

            <div className="premium-contract-input">
                <CKEditor
                    editor={ClassicEditor}
                    data={formData?.pcDescription}
                    config={{ toolbar: toolbarConfig }}
                    onReady={(editor) => {
                        // You can store the "editor" and use when it is needed.
                        console.log('Editor is ready to use!', editor);
                    }}
                    onChange={(event, editor) => {
                        const data = editor?.getData();
                        setFormData((cuData) => ({ ...cuData, pcDescription: data }));
                    }}
                />
            </div>
            <ProductInputField title="Validity" name="pcValidate" />

            <ProductTextAreaField title="Notes" name="note" />
        </div>
    );
}

export default PremiumContractInputs;
